/** GPU 厂商设备清单 resourceType（含 vGPU 等变体） */
export function isGpuInventoryResourceType(resourceType: string): boolean {
  return /gpu/i.test(String(resourceType ?? '').trim());
}
